import { Loading as Icon } from '@opositandopn/ui';
import classnames from 'classnames';

import { BaseComponentProps } from '../../types/base-component.types';

import styles from './Loading.module.scss';

function Loading({ className }: BaseComponentProps) {
  return (
    <div className={classnames(styles['main'], className)}>
      <Icon />
    </div>
  );
}

export { Loading };
